/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Showcase_Nosummary1Inputs */

const zh_showcase_nosummary1 = /** @type {(inputs: Showcase_Nosummary1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无摘要`)
};

const en_showcase_nosummary1 = /** @type {(inputs: Showcase_Nosummary1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No summary`)
};

const es_showcase_nosummary1 = /** @type {(inputs: Showcase_Nosummary1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin resumen`)
};

/**
* | output |
* | --- |
* | "No summary" |
*
* @param {Showcase_Nosummary1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const showcase_nosummary1 = /** @type {((inputs?: Showcase_Nosummary1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Showcase_Nosummary1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_showcase_nosummary1(inputs)
	if (locale === "en") return en_showcase_nosummary1(inputs)
	return es_showcase_nosummary1(inputs)
});
export { showcase_nosummary1 as "showcase_noSummary" }